// extracted by mini-css-extract-plugin
export default {"wrapper":"SidePanel_wrapper__rIVip","opened":"SidePanel_opened__YL+7D","overlay":"SidePanel_overlay__MMfQ2"};